import dynamic from 'next/dynamic';
const Slider = dynamic(() => import('./Slider'));
const ImageWithTextSlide = dynamic(() => import('./ImageWithTextSlide'));

export { Slider };
export { ImageWithTextSlide };
